import React, {useState, FormEvent} from 'react';
import Input from '../Input';
import api from '../../Services/api';
import { useAblContext } from '../../Hooks/useAblContext';
import { Modal, Button, Jumbotron } from 'react-bootstrap';

interface PanelEditUserProps {
  show: boolean,
  onClose: Function,
  onUserCreate: Function,
}

const PanelEditUser: React.FC<PanelEditUserProps> = ({show, onClose, onUserCreate}) => {
  const [name, setName] = useState('')
  const [login, setLogin] = useState('')
  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')

  const abl = useAblContext();

  const handleCleanData = () => {
    setName('');
    setLogin('');
    setPassword('');
    setEmail('');
  }

  const handleCreateUser = async (e: FormEvent) => {
    try{
      e.preventDefault();
      const body = {
        name,
        login: email,
        password,
        email,
        role: 'banca'
      };
      const response = await api.post('user', body, {
        headers: { authorization: abl.token}
      })

      if(response.data){
        alert("Cadastro realizado.")
        onUserCreate(response.data);
        handleCleanData();
        onClose();
        return;
      }
    }catch(err) {
      alert('Erro ao realizar cadastro.');
    }

  }

  return (
    <Modal size="lg" show={show} onHide={() => onClose()} animation={false} centered>
      <Modal.Header closeButton>
        <Modal.Title>Criação de usuários para Banca</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group">
              <Input
              name={"nome"}
              type="text"
              value={name}
              placeholder="Digite o nome"
              onChange={e => setName(e.target.value)}
            />
          </div>
          <div className="form-group">
            <Input
              name={"email"}
              type="text"
              value={email}
              placeholder="Digite o e-mail"
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <Input
              name={"password"}
              type="password"
              value={password}
              placeholder="Digite a senha"
              onChange={e => setPassword(e.target.value)}
            />
          </div>

        </form>
      </Modal.Body>
      <Modal.Footer>
      <Button size="lg" variant="dark" onClick={handleCreateUser}>
          Criar usuário
        </Button>
        {/* <input name="enviar" type="submit" value="Criar usuário" onClick={handleCreateUser}/> */}
      </Modal.Footer>
    </Modal>
    // <>
    //   <div className="userPanel">
    //     <div className="modal-content">
    //       <div className="modal-header">
    //         <h5 className="modal-title" id="exampleModalLongTitle">Criar usuário</h5>
    //         <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => onClose()}>
    //           <span aria-hidden="true">&times;</span>
    //         </button>
    //       </div>
    //       <div className="modal-body">
    //         <form>
    //           <div className="form-group">
    //             <Input
    //               name={"nome"}
    //               type="text"
    //               value={name}
    //               placeholder="Digite o nome"
    //               onChange={e => setName(e.target.value)}
    //             />
    //           </div>
    //           <div className="form-group">
    //             <Input
    //               name={"email"}
    //               type="text"
    //               value={email}
    //               placeholder="Digite o e-mail"
    //               onChange={e => setEmail(e.target.value)}
    //             />
    //           </div>
    //           <div className="form-group">
    //             <Input
    //               name={"password"}
    //               type="password"
    //               value={password}
    //               placeholder="Digite a senha"
    //               onChange={e => setPassword(e.target.value)}
    //             />
    //           </div>
    //             <input name="enviar" type="submit" value="Salvar" onClick={handleCreateUser}/>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    // </>
  )
}

export default PanelEditUser;
